var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.showSpinner)?_c('span',{class:['loader-wrapper', _vm.position]},[_c('div',{class:['loader', _vm.color],style:({
        width: _vm.size,
        height: _vm.size
      })}),(_vm.text != undefined)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()]):_vm._e(),_vm._t("default",null,{"isLoading":_vm.loading})],2)}
var staticRenderFns = []

export { render, staticRenderFns }